import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';
import { HomePrivacyTermsHeader } from '../../shared/components/home-privacy-terms-header/home-privacy-terms-header.component';

@Component({
  selector: 'app-home-privacy',
  templateUrl: './home-privacy.component.html',
  styleUrls: ['./home-privacy.component.scss']
})
export class HomePrivacyComponent extends BaseComponent implements OnInit {

  header: HomePrivacyTermsHeader;

  constructor(
    public override responsive: ResponsiveService,
    public override transloco: TranslocoService,
  ) {
    super(responsive, transloco);
  }

  ngOnInit(): void {
    this.header = {
      imgSrc: "assets/images/img_privacy.jpg",
      titleTranslocoKey: "home.privacy.title"
    }
  }

}
